/**
 * HTML taglerini kaldırıp sadece metin içeriğini döndürür.
 * Gelen string entity-encoded olabilir (&lt; &gt; &amp; &quot; vb.); hepsini decode eder.
 *
 * @param {string} html - HTML string (entity-encoded olabilir)
 * @returns {string} Sadece metin içeriği, tag'siz ve entity'leri decode edilmiş
 *
 * @example
 * convertHtmlToText('&lt;h4&gt;&lt;span style="..."&gt;Zihin &amp;amp; Para Bilinci...&lt;/span&gt;&lt;/h4&gt;')
 * // => "Zihin & Para Bilinci..."
 */
export function convertHtmlToText(html) {
  if (!html || typeof html !== 'string') return ''

  const decodeEntities = (str) =>
    str
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&apos;/g, "'")

  let text = html
  // Önce entity'leri decode et ki gerçek HTML'e dönüşsün
  text = decodeEntities(text)
  // Tüm HTML taglerini kaldır
  text = text.replace(/<[^>]*>/g, '')
  // Metin içinde kalan entity'leri decode et (örn. "Zihin &amp; Para")
  text = decodeEntities(text)
  // Fazla boşluk ve satır sonlarını tek boşluğa indir, başı sonu temizle
  text = text.replace(/\s+/g, ' ').trim()

  return text
}
